// extracted by mini-css-extract-plugin
module.exports = {"input-position-v1":"styles_input-position-v1__27r91"};